import React, { Component } from 'react';
import fire, { auth, provider } from '../fire';
import Header from '../header';
import Hero from '../hero';


let database = fire.database();

class Trailers extends Component {
  constructor(props) {
    super(props);

    // this.database = fire.database().ref().child('recommendation');
    this.database = fire.database().ref().child('movies');

    this.state = { 
      movies: [],
      id: null,
      recommendation: 2,
      messages: [],
      user: null // <-- user authentication
    }; // <- set up react state
  }

  componentDidMount(){
    this.database.on('value', snap => {
      // console.log(snap.val());
      this.setState({
        // recommendation : snap.val()
           // id: snap.val()
           movies: snap.val()
      })
    })
  }

  componentWillUnmount() {
    this.firebaseRef.off();
  }


  onStarClick(nextValue, prevValue, name) {
      this.setState({rating: nextValue});
  }

  render() {
    const { rating } = this.state;
    console.log(this.state.movies);
    return (
      <div className="movie">
        <div className="movielist">
          <div className="moviedetails">          </div>
            <ul className="topMovies">
              {this.state.movies.map((movie, i) => 

                <div key={i} className="col-md-8"> 
                  <div className="trailerList col-xs-12 cards">
                    <iframe width="720" height="315" src={'https://www.youtube.com/embed/'+movie.trailer_url.substr(32)} frameborder="0" allowfullscreen></iframe>
                    <div className="moviedetails"> 
                    </div>
                  </div>
                </div>
                )}
            </ul>
            <div>
            </div>
        </div>
      </div>
    );
  }
}

export default Trailers;


// WEBPACK FOOTER //
// ./src/components/trailers.js